/**
 * Remove a project from the state.
 * @param {Object} state - The current state.
 * @param {Object} action - Details of the action. Holds the key property which is used to call a computed function.
 * @return {Object} The new state. Adds the project to the projects array.
*/

export default function removeProject(state, action) {
  const { id } = action

  return Object.assign({}, state, {
    projects: state.projects.filter(p => p.id !== id)
  })
}



// WEBPACK FOOTER //
// ./src/reducers/removeProject.js